import { render, staticRenderFns } from "./HomeSolution.vue?vue&type=template&id=217edc74&scoped=true&"
import script from "./HomeSolution.vue?vue&type=script&lang=js&"
export * from "./HomeSolution.vue?vue&type=script&lang=js&"
import style0 from "./HomeSolution.vue?vue&type=style&index=0&id=217edc74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217edc74",
  null
  
)

export default component.exports